const addAddress = (form) => {
	var data = $(form).serialize();
	$.ajax({
		url: '/webapp/wcs/stores/servlet/CVAddressAdd?quantity_*=&isPickupItem_*=&orderItemId_*=&shipmodeId_*=&addressId_*=',
		cache: false,
		type: 'POST',
		data: data,
		success: function (json) {
			return false;
		},
	});
};

const addAddressSubmit = (form) => {
	form.email1.value = form.email1.value.toLowerCase();
	form.phone1Part1.value = form.phone1.value;
	if ($('#create-password:visible').length > 0 && form.logonPassword.value.length > 0) {
		form.logonId.value = form.email1.value;
		form.logonIdVerify.value = form.email1Verify.value;
		$(form).attr('action', 'UserRegistrationAdd');
		//form.action.value = '/webapp/wcs/stores/servlet/UserRegistrationAdd';
	}
	if (typeof form.sendMeEmailCheckBox != 'undefined') form.sendMeEmail.value = form.sendMeEmailCheckBox.checked ? 'true' : 'false';
};

export { addAddress, addAddressSubmit };
